module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_9005.13cccd54.png";